/* Cool Bamboo · weighted blanket product page (ClickUp 1amndjnh8yq).
   Size cards -> hidden variant id of the theme's product-form (AJAX add, UpCart). One product with Color + Size
   (merged 2026-10-26): colour swatches switch the variant, the size cards, the gallery and the weight table rows.
   Fallback for a Size-only product: swatches are links to the sibling colour products and keep the chosen size.
   Weight rule (design + Sleep Foundation): a blanket should be 7% to 12% of body weight, closest to 10% wins,
   lighter wins a tie, lightest blanket (7 lb) suits 70 lb and up. */
(function () {
  'use strict';
  var MIN = 0.07, MAX = 0.12, TARGET = 0.10, EPS = 1e-9;

  var hero = document.querySelector('[data-cbwb-hero]');
  var data = null;
  if (hero) {
    try { data = JSON.parse(hero.querySelector('[data-cbwb-data]').textContent); } catch (e) { data = null; }
  }
  var sizes = (data && data.sizes) || [];
  var variants = (data && data.variants) || [];
  var fmt = null;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: (data && data.currency) || 'USD' }); } catch (e) { fmt = null; }

  function money(c) { return fmt ? fmt.format(c / 100) : '$' + (c / 100).toFixed(2); }
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function pct(lb, bw) { return Math.round((lb / bw) * 1000) / 10; }
  function sizeByKey(key) { for (var i = 0; i < sizes.length; i++) { if (sizes[i].key === key) { return sizes[i]; } } return null; }
  function variantById(id) { for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) { return variants[i]; } } return null; }
  /* the colour currently shown (merged product only) */
  var curColor = null;
  function variantFor(key, color) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].key === key && (!variants[i].color || variants[i].color === color)) { return variants[i]; }
    }
    return null;
  }
  function variantByKey(key) { return variantFor(key, curColor); }
  function rangeText(lb) { return Math.max(Math.round(lb / MAX), 70) + ' to ' + Math.round(lb / MIN) + ' lb'; }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) { n.className = cls; } if (text != null) { n.textContent = text; } return n; }
  /* only sizes this product sells */
  function sold() { return sizes.filter(function (s) { return !!variantByKey(s.key); }); }

  function recommend(bw) {
    if (bw < 70) { return { state: 'child' }; }
    var list = sold();
    var fits = list.filter(function (s) { return s.lb >= MIN * bw - EPS && s.lb <= MAX * bw + EPS; })
      .sort(function (a, b) {
        var d = Math.abs(a.lb / bw - TARGET) - Math.abs(b.lb / bw - TARGET);
        return Math.abs(d) < 1e-6 ? a.lb - b.lb : d;
      });
    if (fits.length) { return { state: 'fit', best: fits[0], fits: fits, pct: pct(fits[0].lb, bw) }; }
    var lighter = list.filter(function (s) { return s.lb < MIN * bw; }).sort(function (a, b) { return b.lb - a.lb; })[0];
    var heavier = list.filter(function (s) { return s.lb > MAX * bw; }).sort(function (a, b) { return a.lb - b.lb; })[0];
    return { state: 'none', lighter: lighter, heavier: heavier };
  }
  window.CBWB = { recommend: recommend, select: function () { return false; } };

  /* ================= Hero ================= */
  if (hero && data) {
    var form = document.getElementById('product-form-cbwb-' + hero.getAttribute('data-section'));
    var idInput = form ? form.querySelector('[data-cbwb-id]') : null;
    var radios = hero.querySelectorAll('[data-cbwb-size]');
    var atc = hero.querySelector('[data-cbwb-atc]');
    var sticky = hero.querySelector('[data-cbwb-sticky]');
    if (data.merged) {
      var first = idInput ? variantById(idInput.value) : null;
      curColor = (first && first.color) || (variants[0] && variants[0].color) || null;
    }

    var update = function (v) {
      if (!v) { return; }
      if (idInput) { idInput.value = v.id; }
      var priceEl = hero.querySelector('[data-cbwb-price]');
      if (priceEl) { priceEl.textContent = money(v.price); }
      var cmp = hero.querySelector('[data-cbwb-compare]');
      var save = hero.querySelector('[data-cbwb-save]');
      var onSale = v.compare && v.compare > v.price;
      if (cmp) { cmp.hidden = !onSale; if (onSale) { cmp.textContent = money(v.compare); } }
      if (save) {
        save.hidden = !onSale;
        if (onSale) { save.textContent = (save.getAttribute('data-label') || 'Save [pct]%').replace('[pct]', Math.round((v.compare - v.price) / v.compare * 100)); }
      }
      var sv = hero.querySelector('[data-cbwb-size-val]');
      if (sv) { sv.textContent = v.option; }
      var fit = hero.querySelector('[data-cbwb-fit]');
      if (fit) {
        var cfg = sizeByKey(v.key);
        fit.textContent = cfg ? (fit.getAttribute('data-prefix') + ' ' + rangeText(cfg.lb) + ' ' + fit.getAttribute('data-suffix')) : '';
      }
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? atc.getAttribute('data-label') : atc.getAttribute('data-soldout');
      }
      if (sticky) {
        var sp = sticky.querySelector('[data-cbwb-sticky-price]');
        if (sp) { sp.textContent = money(v.price); }
        var line = sticky.querySelector('[data-cbwb-sticky-line]');
        if (line) { var c = v.color || line.getAttribute('data-color'); line.textContent = v.option + (c ? ' / ' + c : ''); }
        var simg = sticky.querySelector('.cbwb-sticky__img');
        if (simg && v.image && simg.getAttribute('src') !== v.image) { simg.removeAttribute('srcset'); simg.src = v.image; }
        var sb = sticky.querySelector('[data-cbwb-sticky-atc]');
        if (sb && atc) { sb.disabled = !v.available; sb.textContent = atc.textContent; }
      }
      each(hero.querySelectorAll('[data-cbwb-swatch]'), function (a) {
        var map = {};
        (a.getAttribute('data-map') || '').split(',').forEach(function (p) { var kv = p.split(':'); if (kv[0]) { map[kv[0]] = kv[1]; } });
        var id = map[v.key];
        a.href = a.getAttribute('data-base') + (id ? a.getAttribute('data-sep') + 'variant=' + id : '');
      });
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) { /* ignore */ }
      try { document.dispatchEvent(new CustomEvent('cbwb:variant', { detail: { variant: v } })); } catch (e) { /* ignore */ }
    };

    each(radios, function (r) {
      r.addEventListener('change', function () { if (r.checked) { update(variantById(r.value)); } });
    });

    var selectSize = function (key) {
      var hit = null;
      each(radios, function (r) { if (!hit && r.getAttribute('data-key') === key) { hit = r; } });
      if (!hit) { return false; }
      if (!hit.checked) {
        hit.checked = true;
        hit.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    };
    window.CBWB.select = selectSize;

    /* Quantity: keep events bubbling so snippets/cb-fs-qty.liquid (Goalify bar) follows */
    var qty = form ? form.querySelector('[data-cbwb-qtyi]') : null;
    each(hero.querySelectorAll('[data-cbwb-qty]'), function (b) {
      b.addEventListener('click', function () {
        if (!qty) { return; }
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-cbwb-qty'), 10);
        qty.value = Math.max(1, Math.min(99, n));
        qty.dispatchEvent(new Event('input', { bubbles: true }));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (qty) {
      qty.addEventListener('change', function () {
        var n = parseInt(qty.value, 10);
        if (!(n >= 1)) { qty.value = 1; } else if (n > 99) { qty.value = 99; }
      });
    }

    /* Errors from the theme's product-form (e.g. stock) */
    if (form) {
      var err = form.querySelector('[data-cbwb-err]');
      form.addEventListener('cart:error', function (e) {
        if (!err) { return; }
        err.textContent = (e.detail && e.detail.error) || 'Something went wrong. Please try again.';
        err.hidden = false;
      });
      form.addEventListener('variant:add', function () { if (err) { err.hidden = true; } });
    }

    /* Gallery */
    var track = hero.querySelector('[data-cbwb-track]');
    var thumbs = hero.querySelectorAll('[data-cbwb-thumb]');
    var tlist = hero.querySelector('.cbwb-gal__tlist');
    var setCurrent = function (i) {
      each(thumbs, function (t, k) {
        if (k === i) {
          t.setAttribute('aria-current', 'true');
          if (tlist) {
            var vertical = tlist.scrollHeight > tlist.clientHeight + 2 && getComputedStyle(tlist).flexDirection === 'column';
            if (vertical) {
              if (t.offsetTop < tlist.scrollTop || t.offsetTop + t.offsetHeight > tlist.scrollTop + tlist.clientHeight) { tlist.scrollTo({ top: t.offsetTop - 8, behavior: 'smooth' }); }
            } else if (t.offsetLeft < tlist.scrollLeft || t.offsetLeft + t.offsetWidth > tlist.scrollLeft + tlist.clientWidth) {
              tlist.scrollTo({ left: t.offsetLeft - 8, behavior: 'smooth' });
            }
          }
        } else {
          t.removeAttribute('aria-current');
        }
      });
    };
    /* indexes of the slides that are not hidden (another colour's images are hidden) */
    var visible = function () {
      var out = [];
      if (track) { each(track.children, function (s, k) { if (!s.hidden) { out.push(k); } }); }
      return out;
    };
    if (track) {
      each(thumbs, function (t, k) {
        t.addEventListener('click', function () {
          var slide = track.children[k];
          if (slide) { track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }); }
          setCurrent(k);
        });
      });
      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) { return; }
        tick = window.requestAnimationFrame(function () {
          tick = null;
          if (!track.clientWidth) { return; }
          var vis = visible();
          var k = vis[Math.min(vis.length - 1, Math.round(track.scrollLeft / track.clientWidth))];
          if (k != null) { setCurrent(k); }
        });
      }, { passive: true });
    }

    /* Colour swatches of a merged product: same product, other variant */
    var swatches = hero.querySelectorAll('[data-cbwb-color]');
    var setColor = function (color) {
      if (!color || color === curColor) { return; }
      var key = null;
      each(radios, function (r) { if (r.checked) { key = r.getAttribute('data-key'); } });
      var next = variantFor(key, color);
      if (!next) { for (var i = 0; i < variants.length; i++) { if (variants[i].color === color) { next = variants[i]; break; } } }
      if (!next) { return; }
      curColor = color;
      each(radios, function (r) {
        var vv = variantFor(r.getAttribute('data-key'), color);
        var card = r.closest('.cbwb-size');
        if (!vv) { if (card) { card.hidden = true; } return; }
        if (card) {
          card.hidden = false;
          card.classList.toggle('is-na', !vv.available);
          var p = card.querySelector('[data-cbwb-size-price]');
          if (p) { p.textContent = money(vv.price); }
        }
        r.value = vv.id;
        r.checked = vv.id === next.id;
      });
      each(swatches, function (s) {
        var on = s.getAttribute('data-cbwb-color') === color;
        s.classList.toggle('is-current', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var cv = hero.querySelector('[data-cbwb-color-val]');
      if (cv) { cv.textContent = color; }
      if (track) {
        var low = color.toLowerCase();
        each(track.children, function (s) { var c = s.getAttribute('data-color'); s.hidden = !!c && c !== low; });
        each(thumbs, function (t) { var c = t.getAttribute('data-color'); t.hidden = !!c && c !== low; });
        track.scrollTo({ left: 0 });
        var vis = visible();
        if (vis.length) {
          setCurrent(vis[0]);
          var im = track.children[vis[0]].querySelector('img');
          if (im) { im.loading = 'eager'; }
        }
      }
      update(next);
      try { document.dispatchEvent(new CustomEvent('cbwb:color', { detail: { color: color, variants: variants } })); } catch (e) { /* ignore */ }
    };
    each(swatches, function (s) {
      s.addEventListener('click', function () { setColor(s.getAttribute('data-cbwb-color')); });
    });

    /* Prefetch the sibling colour page on intent */
    each(hero.querySelectorAll('[data-cbwb-swatch]'), function (a) {
      var done = false;
      var go = function () {
        if (done) { return; }
        done = true;
        var l = document.createElement('link');
        l.rel = 'prefetch'; l.href = a.href;
        document.head.appendChild(l);
      };
      a.addEventListener('pointerenter', go);
      a.addEventListener('focus', go);
    });

    /* Compact finder in the buy box */
    var hBw = hero.querySelector('[data-cbwb-hbw]');
    var hBtn = hero.querySelector('[data-cbwb-hfind]');
    var hOut = hero.querySelector('[data-cbwb-hout]');
    var say = function (parts) {
      hOut.textContent = '';
      parts.forEach(function (p) { hOut.appendChild(typeof p === 'string' ? document.createTextNode(p) : p); });
      hOut.hidden = false;
    };
    var runFind = function () {
      var bw = parseFloat(hBw.value);
      if (!(bw >= 30 && bw <= 600)) { say(['Enter a body weight between 30 and 600 lb.']); return; }
      var r = recommend(bw);
      if (r.state === 'child') {
        say([bw < 50 ? 'We cannot recommend a blanket at this body weight. See the safety notes below.' : 'Our lightest blanket is 7 lb, which suits about 70 lb and up. We do not make a lighter one.']);
        return;
      }
      if (r.state === 'fit') {
        selectSize(r.best.key);
        say(['We suggest the ', el('strong', null, r.best.label + ' (' + r.best.lb + ' lb)'), ', about ' + r.pct + '% of your body weight. Selected above.']);
        return;
      }
      var near = r.lighter || r.heavier;
      if (near) { selectSize(near.key); }
      var names = [];
      if (r.lighter) { names.push(r.lighter.label + ' (lighter)'); }
      if (r.heavier) { names.push(r.heavier.label + ' (heavier)'); }
      say(['No size lands inside 7% to 12% at ' + bw + ' lb. Closest: ' + names.join(' or ') + '. ' + (near ? near.label + ' is selected above. ' : '') + 'If unsure, start lighter.']);
    };
    if (hBw && hBtn && hOut) {
      hBtn.addEventListener('click', runFind);
      hBw.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); runFind(); } });
    }

    /* Sticky bar once the main button has scrolled above the viewport (scroll check, so a jump back to the top hides it too) */
    if (sticky && atc) {
      var sbtn = sticky.querySelector('[data-cbwb-sticky-atc]');
      var on = null, raf = null;
      var check = function () {
        raf = null;
        var show = atc.getBoundingClientRect().bottom < 0;
        if (show === on) { return; }
        on = show;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (sbtn) { sbtn.tabIndex = show ? 0 : -1; }
      };
      window.addEventListener('scroll', function () { if (!raf) { raf = window.requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', function () { if (!raf) { raf = window.requestAnimationFrame(check); } });
      check();
    }

    /* App blocks that render nothing (back in stock, order limits) must not add a flex gap */
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (en) { en.target.classList.toggle('is-empty', en.target.offsetHeight === 0); });
      });
      each(hero.querySelectorAll('.cbwb-buy__app'), function (a) { ro.observe(a); });
    }
  }

  /* ================= Weight table rows follow the colour of a merged product ================= */
  document.addEventListener('cbwb:color', function (e) {
    var color = e.detail && e.detail.color;
    if (!color) { return; }
    each(document.querySelectorAll('[data-cbwb-row]'), function (row) {
      var vv = variantFor(row.getAttribute('data-cbwb-row'), color);
      if (!vv) { return; }
      var id = row.querySelector('[data-cbwb-row-id]');
      if (id) { id.value = vv.id; }
      var pr = row.querySelector('.cbwb-table__price');
      if (pr) { pr.textContent = money(vv.price); }
      var b = row.querySelector('[data-cbwb-row-btn]');
      if (b) {
        b.disabled = !vv.available;
        b.textContent = vv.available ? b.getAttribute('data-label') : b.getAttribute('data-soldout');
        b.setAttribute('aria-label', b.getAttribute('data-aria') + ', ' + color);
      }
    });
    each(document.querySelectorAll('[data-cbwb-color-name]'), function (n) { n.textContent = color; });
  });

  /* ================= Weight guide calculator ================= */
  each(document.querySelectorAll('[data-cbwb-calc]'), function (calc) {
    var box = calc.parentNode;
    var input = calc.querySelector('[data-cbwb-bw]');
    var out = box.querySelector('[data-cbwb-calc-out]');
    if (!input || !out) { return; }

    var selectBtn = function (s) {
      var b = el('button', 'cbwb-btn cbwb-btn--primary cbwb-btn--sm', 'Select ' + s.label + ' above');
      b.type = 'button';
      b.addEventListener('click', function () {
        window.CBWB.select(s.key);
        var target = document.getElementById('cbwb-hero');
        if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
      return b;
    };

    calc.addEventListener('submit', function (e) {
      e.preventDefault();
      var bw = parseFloat(input.value);
      out.textContent = '';
      out.hidden = false;
      if (!(bw >= 30 && bw <= 600)) { out.appendChild(el('p', null, 'Enter a body weight between 30 and 600 lb.')); return; }
      var r = recommend(bw);
      if (r.state === 'child') {
        if (bw < 50) {
          out.appendChild(el('p', 'cbwb-big', 'We cannot recommend a blanket at this body weight.'));
          out.appendChild(el('p', null, 'The Sleep Foundation says weighted blankets are generally considered safe for children who are at least 3 years old and weigh at least 50 pounds. Check with your child’s doctor first.'));
        } else {
          out.appendChild(el('p', 'cbwb-big', 'Our lightest blanket is 7 lb, which suits about 70 lb and up. We do not make a lighter one.'));
          out.appendChild(el('p', null, 'The Sleep Foundation advises that a child’s weighted blanket should not weigh more than 10% of the child’s body weight, and that you check with a doctor first.'));
        }
        return;
      }
      if (r.state === 'fit') {
        var best = r.best;
        var v = variantByKey(best.key);
        var dims = v && v.option.indexOf('(') > -1 ? v.option.split('(').pop().replace(')', '').replace('"x', '" x ') : '';
        out.appendChild(el('p', 'cbwb-big', 'We suggest the ' + best.label + (dims ? ' (' + dims + ')' : '') + ' at ' + best.lb + ' lb.'));
        out.appendChild(el('p', null, 'That is about ' + r.pct + '% of a ' + bw + ' lb body weight, inside our 7% to 12% range.'));
        if (r.fits.length > 1) {
          var others = r.fits.slice(1).map(function (s) { return s.label + ' (' + s.lb + ' lb, ' + pct(s.lb, bw) + '%)'; }).join(', ');
          out.appendChild(el('p', 'cbwb-small', 'Also in range: ' + others + '. Choose the lighter one if you prefer a lighter feel, or pick by how much of the bed you want covered.'));
        }
        out.appendChild(selectBtn(best));
        return;
      }
      out.appendChild(el('p', 'cbwb-big', 'None of our sizes falls inside 7% to 12% at ' + bw + ' lb.'));
      var parts = [];
      if (r.lighter) { parts.push(r.lighter.label + ' at ' + r.lighter.lb + ' lb (' + pct(r.lighter.lb, bw) + '%, lighter than our range)'); }
      if (r.heavier) { parts.push(r.heavier.label + ' at ' + r.heavier.lb + ' lb (' + pct(r.heavier.lb, bw) + '%, heavier than our range)'); }
      out.appendChild(el('p', null, 'Closest options: ' + parts.join(' or ') + '. If you are unsure, start lighter. A blanket that makes it hard to move is too heavy.'));
      var near = r.lighter || r.heavier;
      if (near) { out.appendChild(selectBtn(near)); }
    });
  });
})();
